module.exports = __webpack_public_path__ + "img/mx_seguroportatil.e3f8b354.png";